import React, { memo, type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const IngredientListItemContentContainer = memo(
  (props: PropsWithChildren) => {
    const { children } = props;

    return <View style={styles.outerContainer}>{children}</View>;
  },
);

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    columnGap: theme.spacing['3'],
    rowGap: theme.spacing['2'],
  },
});
